import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const VariableSetConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-3">
      <div>
        <label className={commonStyles.label}>
          Változó neve
        </label>
        <input
          type="text"
          value={node.data.config.variableName || ''}
          onChange={(e) => updateConfig('variableName', e.target.value)}
          className={commonStyles.input}
          placeholder="my_variable"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          A beállítandó változó neve
        </p>
      </div>
      
      <div>
        <label className={commonStyles.label}>
          Változó értéke
        </label>
        <textarea
          value={node.data.config.variableValue || ''}
          onChange={(e) => updateConfig('variableValue', e.target.value)}
          className={commonStyles.textarea}
          rows={3}
          placeholder="{{email_sender}} vagy fix érték"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Használhatsz {`{{változó}}`} szintaxist más változók hivatkozásához
        </p>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>Példák:</strong>
          <ul className="list-disc list-inside mt-1 space-y-1">
            <li><code>customer_name</code> → <code>{`{{email_sender_name}}`}</code></li>
            <li><code>processed_date</code> → <code>2024-01-01</code></li>
            <li><code>full_message</code> → <code>Üzenet: {`{{email_body}}`}</code></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VariableSetConfig;
